import React from 'react';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import servicioTrabajador from '../servicios/ServicioTrabajador';
import { Calendar } from 'primereact/calendar';
import { useFormik } from 'formik';
import { useForm, Controller } from 'react-hook-form';

import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioHttp from '../servicios/ServicioHttp';
import servicioObjetos from '../servicios/ServicioObjetos';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { InputText } from 'primereact/inputtext';
import { DetalleRecibos } from './DetalleRecibos';
import Formulario from './ConsultaReciboTrabajador/Formulario.jsx';

export class ConsultaReciboTrabajador extends React.Component {

    
    constructor() {
        super();
        this.state = {
            paginacion: { registrosPorPagina: 20 },
            inicio: 0,
            trabajador: {},
            emisores: [],
            emisor: {},
            mostrarModal: false,
        }
        this.buscarLink = this.buscarLink.bind(this);

        this.llenar = this.llenar.bind(this);


    }
    
    componentDidMount() {
        this.obtenerRfcsEmisores();
    }

    obtenerRfcsEmisores = () => {
        servicioHttp.consumirPostHttp('/emisor/obtener_por_cliente.json').then(response => {
            if (response.data.error) {
                return this.growl.show({ severity: 'error', summary: '', detail: response.data.mensaje });
            } else {
                let emisores = [];
                for (let i = 0; i < response.data.lista.length; i++) {
                    let objeto = response.data.lista[i];
                    emisores.push({ id: objeto[0], rfc: objeto[1], nombre: objeto[1] + " - " + objeto[2] });
                }
                this.setState({ emisores: emisores });
            }
        }).catch(error => {

        });
    }

    asignarEmisor = (valor) => {
        this.setState({ emisor: valor.emisor });
    }

    cambiaPagina(event) {
        let { paginacion } = this.state;

        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.buscarRecibos(false);
    }
    obtenerPagina() {
        let { paginacion } = this.state;
        servicioTrabajador.paginacion(paginacion).then((response) => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            if (response.data.error === false)
                this.setState({ paginacion: response.data.objeto });
        }).catch((error) => {
            if (error)
                console.log("error");
            return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });
    }

    llenar(objeto) {

        return <div className="CfdiPagos">
            <DetalleRecibos id={objeto.id} app="Mi App React" />
        </div>
    }

    buscarLink(rowData, column) {

        return <div>

            <Link to={{
                pathname: "/consultareciboquadrum/bienvenido/detallerecibos",
                state: { id: column.rowData }
            }} onClick={this.llenar.bind(this, column.rowData)}>Ver Recibos</Link>

        </div>;
    }

    buscarLike() {
        let { trabajador, paginacion } = this.state
        servicioTrabajador.buscar_like(trabajador).then((response) => {
            if (response.data.lista.length === 0) {
                this.growl.show({ life: 5000, severity: 'error', summary: '', detail: response.data.mensaje });
                paginacion['datos'] = response.data.lista;
                this.setState({ paginacion });
            } else {
                this.growl.show({ life: 1000, severity: 'success', summary: '', detail: "Valores encontrados" });
                paginacion['datos'] = response.data.lista;
                this.setState({ paginacion });
            }
        })
    }
    plantillaAutoComplete(entidad) {
        return <div >{entidad.rfc + "-" + entidad.nombre}</div>
    }

    asignarValores = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
    }

    buscarRecibos = (inicio) => {
        let { emisor, paginacion } = this.state;
        if (servicioObjetos.esObjetoVacio(emisor)) {
            this.growl.show({ life: 3000, severity: 'error', summary: '', detail: "Debe de elegir un emisor para realizar la búsqueda" });
            return;
        }
        paginacion.join = {
            "trNominas": "trNominas",
            "alias_trNominas.tcEmisor": "elEmisor"
        };
        if (inicio) {
            paginacion.numeroPagina = 0;
            this.setState({ inicio: 0 });
        }
        paginacion.restricciones = { "alias_elEmisor.rfc": emisor.rfc };
        this.setState({ paginacion: paginacion, trabajador: {} });
        this.obtenerPagina();
    }

    render() {
        let { errores, paginacion, inicio, trabajador, accion, emisores, emisor} = this.state;
        return (<div className="content-section implementation">
            <Growl ref={(el) => this.growl = el} />
            <div className="card card-w-title">
                <h1>Consulta Recibos Trabajador</h1>
                <Formulario emisor={emisor} emisores={emisores} trabajador={trabajador} asignarValores={this.asignarValores} asignarEmisor={this.asignarEmisor} buscarRecibos={this.buscarRecibos} buscarLike={this.buscarLike.bind(this)} growl={this.growl}/>
                <br />
                <div className="content-section implementation">
                    <DataTable value={paginacion.datos} editable={true} selectionMode="single" scrollable={true} resizableColumns={true} responsive={true}>
                        <Column field="rfc" header="Rfc" />
                        <Column field="nombre" header="Nombre" />
                        <Column field="curp" header="Curp" />

                        <Column header="Consultar Recibos" body={this.buscarLink} style={{ textAlign: 'center', width: '8em' }}> </Column>

                    </DataTable>
                    <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                </div>
            </div>
        </div>
        );
    }

}